import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";
import axios from "axios";
import dayjs from "dayjs";

export const getRevenueDetails = async (authToken, userInfo, tenantId, setLoader, filters = null, location = null) => {
  setLoader(true);
  const postData = {
    RequestInfo: {
      apiId: "Rainmaker",
      authToken: authToken,
      msgId: "1781606952133|en_IN",
      userInfo: { ...userInfo, active: true, tenantId: tenantId, permanentCity: null },
    },
  };

  try {
    let response = null;
    if (!filters) {
      const url = `${Urls.obps.totalAmountOfCharges}${location ? `?organisationName=${location.split(" ")[0]}` : ""}`;
      response = await axios.post(url, postData);
    } else {
      const params = new URLSearchParams();
      if (filters?.createdFrom) {
        params.append("fromDate", formatDateToDDMMYYYY(filters.createdFrom));
      }
      if (filters?.createdTo) {
        params.append("toDate", formatDateToDDMMYYYY(filters.createdTo));
      }
      if (filters?.selectedFeeType) {
        params.append("feeType", filters.selectedFeeType);
      }
      if (filters?.developmentAuthorityName || location) {
        params.append("organisationName", filters?.developmentAuthorityName?.split(" ")[0] || location?.split(" ")[0]);
      }
      response = await axios.post(`${Urls.obps.taxHeadEstimateSearch}?${params.toString()}`, postData);
    }

    return response.data?.PaymentHeadDefinition ? response?.data?.PaymentHeadDefinition : response?.data;
  } catch (error) {
    console.log(error);
  } finally {
    setLoader(false);
  }
};

export const formatLabel = (str = "") => {
  return str
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

const formatDateToDDMMYYYY = (date) => {
  return dayjs(date).format("DD-MM-YYYY");
};

export const formatTimestamp = (timestamp) => {
  return timestamp ? dayjs(timestamp).format("DD-MM-YYYY") : "-";
};
